<!-- custom-radio-button.component.html -->
<mat-radio-group [class.horizontal]="orientation() === 'horizontal'" [class.vertical]="orientation() !== 'horizontal'">
    @for (option of options(); track option.value) {
        <div class="radio-option" [class.selected]="selectedValue() === option.value" (click)="onSelectionChange(option.value)">
        <mat-radio-button [value]="option.value" class="hidden-radio"></mat-radio-button>
        <div class="radio-box">
            @if (selectedValue() === option.value) {
            <div class="radio-indicator"></div>
            }
        </div>
        <div class="radio-content">
            <div class="radio-label">{{ option.label }}</div>
            <div class="radio-description">{{ option.description }}</div>
        </div>
        </div>
    }
</mat-radio-group>
